import RemoveDocumentModal from './RemoveDocumentModal.component';

export default RemoveDocumentModal;
